import {UseQueryResult, useQuery} from 'react-query';

import {getArticles, getArticleBySlug} from 'client/articles/utils/api-client';
import {ContentTypeArticle} from 'client/articles/components/articles-list/articles-list';

import {Article, Articles} from '../types';

export function useArticles(contentType: ContentTypeArticle): UseQueryResult<Articles> {
    return useQuery(`blog-${contentType}`, async () => {
        const {data} = await getArticles(contentType);

        return data;
    });
}


export function useArticleBySlug(slug: string): UseQueryResult<Article> {
    return useQuery(['article', slug], async () => {
        const {data} = await getArticleBySlug(slug);

        return data;
    });
}
